import React from "react"
import { TFunction } from "i18next"
import { twMerge } from "tailwind-merge"
import {  } from "date-fns"
import { parseISO } from "date-fns"
import DownLoadPdfIcon from "components/Elements/Icons/DownLoadPdf"
import { CheckBoxBikeFleet } from "../Partials/Elements/CheckBoxBikeFleet"
import { getLabelFromStatusNumber } from "../utils"
import { StatusEnum } from "../types/bikeFleetType"
import { Link } from "react-router-dom"
import { privateRoutes } from "router/routes"
import dateService from "services/date"

export const useColumn = (
	onToggleChoice: (val: string) => void = undefined,
	onToggleAllChoice: React.ChangeEventHandler<HTMLInputElement>,
	isAllChecked: string | false,
	status: string | number,
	currentBikeFleetStatusSelected: string | false,
	t: TFunction,
	viewProoRegistration: (val: string) => void
) => {
	return React.useMemo(
		() => [
			{
				Header: () => {
					const isNotAllStatus = status !== String(StatusEnum.ALL)
					const isCurrentStatus = status === currentBikeFleetStatusSelected
					const hasNotRowSelected = !currentBikeFleetStatusSelected
					return (
						<CheckBoxBikeFleet
							isSelectable={isNotAllStatus && (isCurrentStatus || hasNotRowSelected)}
							className={"border-white checked:border-white"}
							id="allCheck"
							onChange={onToggleAllChoice}
							checked={isAllChecked === status}
						/>
					)
				},
				accessor: "choice",
				Cell: (cell) => {
					const currentValue = cell.cell.row.cells[1].value
					const checked = cell.cell.value
					return (
						<CheckBoxBikeFleet
							className={twMerge(" border-gray-400")}
							id={`rowCheck-${cell.cell.row.id}`}
							isSelectable={
								currentBikeFleetStatusSelected === false
									? true
									: currentBikeFleetStatusSelected ===
									  cell.cell.row.original.status
							}
							onChange={() => {
								onToggleChoice(currentValue)
							}}
							checked={checked}
						/>
					)
				},
				disableSortBy: true,
			},
			{
				Header: t("bikeFleet.columns.fnuciCode", { ns: "bike" }),
				accessor: "fnuciCode",
				Cell: ({ cell: { value } }) => (
					<Link
						className="hover:underline"
						to={`${privateRoutes.bike.basePath}/${value}`}
					>
						{value}
					</Link>
				),
			},
			{
				Header: t("bikeFleet.columns.brand", { ns: "bike" }),
				accessor: "brand",
			},
			{
				Header: t("bikeFleet.columns.model", { ns: "bike" }),
				accessor: "model",
			},
			{
				Header: t("bikeFleet.columns.type", { ns: "bike" }),
				accessor: "type",
			},
			{
				Header: t("bikeFleet.columns.color", { ns: "bike" }),
				accessor: "color",
			},
			{
				Header: t("bikeFleet.columns.status", { ns: "bike" }),
				accessor: "status",
				Cell: ({ cell: { value } }) => <>{getLabelFromStatusNumber(Number(value))}</>,
			},
			{
				Header: t("bikeFleet.columns.proofRegister", { ns: "bike" }),
				accessor: "proofOfRegistration",
				Cell: ({ cell }) => {
					return (
						<button
							data-cy="proof-registration"
							onClick={() => viewProoRegistration(cell.row.values.fnuciCode)}
							className="text-black"
						>
							<DownLoadPdfIcon width={25} height={26} />
						</button>
					)
				},
			},
			{
				Header: t("bikeFleet.columns.activation", { ns: "bike" }),
				accessor: "activation",
				sortType: "datetime",
                Cell: ({ cell: { value } }) => {
                    const dateValue = typeof value === "string" ? parseISO(value) : value
                    const formattedDate = dateService.formatDate(
                        dateValue,
                        dateService.getCurrentShortDateFormat()
                    )

                    return <>{formattedDate}</>
                },
			},
		],
		// eslint-disable-next-line react-hooks/exhaustive-deps
		[isAllChecked, status, currentBikeFleetStatusSelected, viewProoRegistration]
	)
}
